var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFacebook = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5553 13.7848C11.5101 13.7848 10.5172 13.7848 10.0659 13.7848C9.82522 13.7848 9.75 13.6945 9.75 13.4689C9.75 12.8671 9.75 12.2503 9.75 11.6486C9.75 11.4078 9.84026 11.3326 10.0659 11.3326H11.5553C11.5553 11.2875 11.5553 10.415 11.5553 10.0088C11.5553 9.40702 11.6606 8.83535 11.9614 8.30882C12.2774 7.76724 12.7287 7.40618 13.3003 7.19557C13.6764 7.06018 14.0525 7 14.4587 7H15.933C16.1436 7 16.2339 7.09026 16.2339 7.30088V9.01588C16.2339 9.22649 16.1436 9.31675 15.933 9.31675C15.5268 9.31675 15.1207 9.31675 14.7145 9.3318C14.3083 9.3318 14.0977 9.52737 14.0977 9.9486C14.0826 10.3999 14.0977 10.8362 14.0977 11.3025H15.8428C16.0835 11.3025 16.1737 11.3928 16.1737 11.6335V13.4538C16.1737 13.6945 16.0985 13.7697 15.8428 13.7697C15.3012 13.7697 14.1428 13.7697 14.0977 13.7697V18.674C14.0977 18.9298 14.0225 19.02 13.7517 19.02C13.1198 19.02 12.503 19.02 11.8712 19.02C11.6455 19.02 11.5553 18.9298 11.5553 18.7041C11.5553 17.1245 11.5553 13.8299 11.5553 13.7848Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.7,
    y: 0.7,
    width: 24.6,
    height: 24.6,
    rx: 5.8,
    stroke: "currentColor",
    strokeWidth: 1.4
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFacebook, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/facebook.81477a5c.svg";
export { ForwardRef as ReactComponent };